import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {BonusBunniesBonusWildAttentionView} from "./BonusBunniesBonusWildAttentionView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

/**
 * Created by Jerker Nord on 2019-11-22.
 */

export class BonusBunniesBonusWildAttentionController extends ReelStopPresentationController {

    private _bonusSymPosition:boolean[][] = [[false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false]];
    private _wildSymPosition:boolean[][] = [[false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false]];
    private _view:BonusBunniesBonusWildAttentionView;
    private _bunnyLanded:boolean;
    private _bunnyLandedCounter:number = 0;
    private _wildLanded:boolean;

    constructor(index:number) {
        super(index, "BonusBunniesBonusWildAttentionController");
        this._view = new BonusBunniesBonusWildAttentionView(ResourcesGroupName.MAIN);
    }

    public getReelJumpingBunnieTL(startReel:number, startRow:number, targetRow:number):TimelineLite {
        return this._view.getReelJumpingBunnieTL(startReel, startRow, targetRow);
    }

    public getRowJumpingBunnieTL(startReel:number, startRow:number, targetRow:number):TimelineLite {
        return this._view.getRowJumpingBunnieTL(startReel, startRow, targetRow);
    }

    public changeWildState(reel:number, row:number, newState:string):void {
        this._view.changeWildState(reel, row, newState);
    }

    public resetAndHideBunnie(reel:number, row:number):void {
        this._view.resetAndHideBunnie(reel, row);
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        if(data.mode == BonusBunniesGameMode.NORMAL) {
            this._bunnyLanded = false;
            this._wildLanded = false;
            for(let i:number = 0; i < 4; i++) {
                for(let j:number = 1; j < 5; j++) {
                    if(data.reels[i][j] == "B") {
                        this._bunnyLanded = true;
                        this._bonusSymPosition[i][j - 1] = true;
                    } else {
                        this._bonusSymPosition[i][j - 1] = false;
                    }
                    if(data.reels[i][j] == "W") {
                        this._wildLanded = true;
                        this._wildSymPosition[i][j - 1] = true;
                    } else {
                        this._wildSymPosition[i][j - 1] = false;
                    }
                }
            }
        }
    }

    private isExpandingWild():boolean {
        if(this._wildLanded == true && this._bunnyLanded == true) {
            return true;
        } else {
            return false;
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId < 4 && this._gameData!.mode == BonusBunniesGameMode.NORMAL) {
            for(let i:number = 0; i < this._bonusSymPosition[data.reelId].length; i++) {
                if(this._bonusSymPosition[data.reelId][i] == true && data.reelId < 4) {
                    if(this._bunnyLandedCounter < 2) {
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_LANDING);
                    } else {
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_LANDING_WIN);
                    }
                    this._bunnyLandedCounter++;
                    this._view.activateLandBunnieAnimation(data.reelId, i);
                }
                if(this._wildSymPosition[data.reelId][i] == true) {
                    SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.WILD_LANDING);
                    if(data.reelId < 3) {
                        this._view.activateLandWildAnimation(data.reelId, i, true);
                    } else {
                        this._view.activateLandWildAnimation(data.reelId, i, false);
                    }
                }
            }
        }
    }

    public resetBunnieAnimations():void {
        this._view.resetBunnieAnimations();
    }

    public resetWildAnimation(reel:number, row:number):void {
        this._view.resetWildAnimation(reel, row);
    }

    public resetAllWildAnimations():void {
        this._view.resetAllWildAnimations();
    }

    public activateHideBunnieanimation(reel:number, row:number):void {
        this._view.activateHideBunnieAnimation(reel, row);
    }

    public abort():void {
        this._view.abort();
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId == 3) {
            //If Wild or Bunny has landed but there is now spreading wild win, clean up.
            if(this.isExpandingWild() == false && (this._view.wildLanded == true || this._view.bunnieLanded == true)) {
                this._view.resetAllWildAnimations();
                this._view.resetBunnieNearWinAnimations();
            }
            this._bunnyLandedCounter = 0;
        }
        this.dispatchCompleteEvent(data.reelId);
    }
}